export default __webpack_public_path__ + "static/media/burgers.6879a097.png";